import { NotReadyI18n } from '@boschebike/ebds-js';
// Set default/start language
import { useEffect, useState } from 'react';
import { getI18n } from '@boschebike/ebds-js/dist-esm/helpers/getI18n.js';

// start with a polyfill that translates numbers but
// returns empty strings for everything else.
let i18ninstance = new NotReadyI18n('en-GB', {});

/**
 * @param {Object} dictionary Dictionary object containing app translations.
 * @param {string} namespace Optional phrase namespace. Will add it as a default key prefix.
 * @returns {I18n}
 */
export const useI18n = (dictionary, namespace) => {
  const [i18n, setI18n] = useState(i18ninstance);
  useEffect(() => {
    // If the recent a.k.a global one is not the dummy one, there's nothign to do.
    if (!(i18n instanceof NotReadyI18n)) {
      return;
    }
    getI18n(dictionary, namespace).then(actualI18n => {
      // set it to the current hook so every component that called it before is rerendered.
      setI18n(actualI18n);
      // and set it in global, so future newly created hooks will skip all of this.
      i18ninstance = actualI18n;
    });
  }, [dictionary, i18n, namespace]);
  return i18n;
};